import { api } from '../../api/fetch';

export const fetchLevels = async (building_id: number) => {
    console.info('fetch building levels');
  return await api.get(`api/v1/buildings/${building_id}/levels/`);
};

export default fetchLevels;
